import Vue from 'vue'
import Router from 'vue-router'
import base from './base'
import login from './login'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: 'diagnosis-pc',
  routes: []
    .concat(base)
    .concat(login),
  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js